"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachToRoot = void 0;
/**
 * Обернуть переменные CSS в объект с корневыми переменными.
 */
var attachToRoot = function (cssVariables) {
    return {
        ':root': cssVariables,
    };
};
exports.attachToRoot = attachToRoot;
//# sourceMappingURL=attachToRoot.js.map